<template>
  <div class="page-container">
    <div class="page-title-container">
      <h1 class="page-title">
        {{ editing ? "Editar local" : "Nuevo local" }}
      </h1>
    </div>
    <div>
      <form class="custom-form" @submit.prevent="save" novalidate>
        <b-card tag="article" no-body style="max-width: 760px" class="custom-card">
          <b-card-header header-tag="section" class="custom-card-header d-flex align-items-center">
            <h3>
              {{ editing ? "Datos del local" : "Datos del nuevo local" }}
            </h3>
          </b-card-header>
          <b-card-body class="custom-card-body p-0">
            <section class="form-section border-0">
              <div>
                <h2 class="form-subtitle">Información general</h2>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="name">Nombre *</label>
                    <input id="name" type="text" v-model.trim="form.name" autocomplete="off"
                      placeholder="Ingresar nombre del local" class="custom-form-control"
                      :class="{ 'custom-form-control-error': $v.form.name.$error }" />
                    <FormError v-if="$v.form.name.$error && !$v.form.name.required" message="El nombre es requerido" />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="form-group mb-0">
                    <label for="address">Dirección *</label>
                    <input id="address" type="text" v-model.trim="form.address" autocomplete="off"
                      placeholder="Ingresar dirección del local" class="custom-form-control"
                      :class="{ 'custom-form-control-error': $v.form.address.$error }" />
                    <FormError v-if="$v.form.address.$error && !$v.form.address.required"
                      message="La dirección es requerida" />
                  </div>
                </div>
              </div>

              <div class="form-group-buttons text-right">
                <router-link :to="{ name: 'location-list' }" class="button button-light">
                  {{ editing ? "Volver" : "Cancelar" }}
                </router-link>
                <button class="button button-primary" type="submit">Guardar</button>
              </div>
            </section>
          </b-card-body>
        </b-card>
      </form>
    </div>
  </div>
</template>

<script>
import { Alert, FormError } from "wize-admin";
import { LocationService } from "@/core/services";
import { required } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";

export default {
  components: {
    FormError
  },
  data() {
    return {
      editing: false,
      form: {
        name: null,
        address: null
      }
    };
  },
  validations: {
    form: {
      name: { required },
      address: { required }
    }
  },
  computed: {
    ...mapGetters({
      business: "app/getBusiness"
    })
  },
  methods: {
    async save() {
      this.$v.$touch();
      if (this.$v.$error) {
        this.$nextTick(() => {
          this.$smoothScroll({
            scrollTo: document.querySelector(".form-error"),
            updateHistory: false,
            offset: -50
          });
        });
        return;
      }

      try {
        await this.$store.dispatch("app/loading", true);
        if (!this.editing) {
          await LocationService.save(this.business.id, this.form);
        } else {
          await LocationService.update(this.business.id, this.$route.params.id, this.form);
        }
        Alert.success("Se almacenó la información correctamente");
        this.$router.push({ name: "location-list" });
      } catch (ex) {
        console.error(ex);
        Alert.error(ex);
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    },
    async load(id) {
      try {
        await this.$store.dispatch("app/loading", true);
        const response = await LocationService.get(this.business.id, id);
        const payload = response.payload;
        this.form.name = payload.name;
        this.form.address = payload.address;
        this.editing = true;
      } catch (ex) {
        console.error(ex);
        Alert.error(ex);
        this.$router.push({ name: "location-list" });
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    }
  },
  async created() {
    if (this.$route.params.id) {
      await this.load(this.$route.params.id);
    }
  }
};
</script>

<style lang="stylus" scoped>
</style>
